import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/web.dom-collections.for-each.js";
import Gikam from '../../core/gikam-core';
export var Position = /*#__PURE__*/function () {
  function Position(position, layoutInstance) {
    _classCallCheck(this, Position);

    this.layoutInstance = layoutInstance;
    this.position = position;
  }

  _createClass(Position, [{
    key: "cleanItems",
    value: function cleanItems() {
      var position = this.layoutInstance.options[this.position];
      var $children = position.$children;
      $children.forEach(function (item) {
        return item.$destroy();
      });
      position.$children = [];
      this.layoutInstance.$children = [];
    }
  }, {
    key: "refreshItems",
    value: function refreshItems(props) {
      if (!Array.isArray(props)) {
        Gikam.error('refreshItems accept array');
        return;
      }

      this.cleanItems();
      var layout = this.layoutInstance;
      var area = layout.options[this.position];
      props.forEach(function (subComp) {
        subComp.renderTo = area.$dom;
        subComp.$root = layout.options.renderTo;
        subComp.$window = layout.$window;
        subComp.$parent = area;
        subComp.allowWidth = parseInt(area.width) || layout.options.allowWidth;
        area.$children.push(Gikam.create(Gikam.toInitialUpperCase(subComp.type), subComp));
      });
    }
  }]);

  return Position;
}();